var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1998 10.9999C20.1998 15.9705 16.1704 19.9999 11.1999 19.9999C9.6575 19.9999 8.20566 19.6119 6.93676 18.9281C5.16687 17.9744 3.9759 18.8611 2.92556 19.0201C2.76623 19.0443 2.60754 18.9864 2.49361 18.8725C2.32065 18.6995 2.28773 18.4321 2.38327 18.2069C2.79551 17.2353 3.17403 15.394 2.65792 13.842C2.36081 12.9487 2.19995 11.9931 2.19995 10.9999C2.19995 6.02941 6.22936 2 11.1999 2C16.1704 2 20.1998 6.02941 20.1998 10.9999Z",
    fill: "white",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.042 10.5262C14.042 10.5262 11.9488 7.68409 11.1999 7.68408C10.4509 7.68408 8.35779 10.5262 8.35779 10.5262M11.1999 8.15776V14.3156V8.15776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.042 10.5262C14.042 10.5262 11.9488 7.68409 11.1999 7.68408C10.4509 7.68408 8.35779 10.5262 8.35779 10.5262M11.1999 8.15776V14.3156",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIc);
export default __webpack_public_path__ + "static/media/purchase_ic.94f81d785e09716b1d15d7638505e04d.svg";
export { ForwardRef as ReactComponent };